import { mapActions } from 'vuex'

// Component
export default {
  name: 'logout-component',
  render() {
    return this.$scopedSlots.default({
      logout: this.logout
    })
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}
